//import './components/util/polyfills';
import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import {unregister} from './registerServiceWorker';

var alertFallback = false;
if (typeof console === "undefined" || typeof console.log === "undefined") {
    console = {};
    if (alertFallback) {
        console.log = function (msg) {
            alert(msg);
        };
    } else {
        console.log = function () { };
    }
}

ReactDOM.render(<App />, document.getElementById('root'));
unregister();